import React from 'react';
import { InputNumber } from 'antd';
import type { WidgetProps } from '../registry';

export const SimpleNumberWidget: React.FC<WidgetProps> = ({
  widget,
  onChange,
  onBlur,
  error,
  warning,
}) => {
  return (
    <div className="rul-widget-field">
      {widget.label && (
        <label className="rul-widget-field-label">
          {widget.label}
          {widget.required && <span className="required">*</span>}
        </label>
      )}
      <InputNumber
        value={widget.value}
        placeholder={widget.placeholder}
        min={widget.min ?? widget.min_value}
        max={widget.max ?? widget.max_value}
        step={widget.step}
        onChange={(value) => onChange?.(widget.name, value)}
        onBlur={() => {
          console.log('[SimpleNumber] onBlur called for', widget.name);
          onBlur?.(widget.name, widget.value);
        }}
        onKeyDown={(e) => {
          // Allow control keys (arrows, backspace, delete, tab, enter, etc.)
          if (e.key.length > 1) return;
          // Allow: digits, minus sign, decimal point
          if (!/[\d\-.]/.test(e.key)) {
            e.preventDefault();
          }
        }}
        status={error ? 'error' : warning ? 'warning' : ''}
        size="large"
        style={{ width: '100%' }}
      />
      {(widget.min !== undefined || widget.max !== undefined) &&
        !error &&
        !warning && (
          <div className="rul-widget-help">
            {widget.min !== undefined && widget.max !== undefined
              ? `Range: ${widget.min} - ${widget.max}`
              : widget.min !== undefined
                ? `Minimum: ${widget.min}`
                : `Maximum: ${widget.max}`}
          </div>
        )}
      {error && <div className="rul-widget-error">{error}</div>}
      {warning && !error && <div className="rul-widget-warning">{warning}</div>}
    </div>
  );
};
